import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routeMeta, SITE_ORIGIN } from '../seo/routeMeta';

// Single source of truth is src/seo/routeMeta.js. The served HTML already
// carries correct per-page tags (stamped by scripts/materialize-routes.js);
// this hook keeps <head> in sync during client-side SPA navigation and for
// JS-rendering crawlers. Derives everything from the current path — any
// argument passed by callers is legacy and intentionally ignored.
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

const usePageMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = routeMeta[pathname] || routeMeta['/'];
    const canonical = `${SITE_ORIGIN}${pathname === '/' ? '/' : pathname}`;
    if (meta.title) {
      document.title = meta.title;
      setMeta('property', 'og:title', meta.title);
    }
    if (meta.description) {
      setMeta('name', 'description', meta.description);
      setMeta('property', 'og:description', meta.description);
    }
    setMeta('property', 'og:url', canonical);
    setCanonical(canonical);
  }, [pathname]);
};

export default usePageMeta;
